<script setup>
import { ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import SettingsSection from 'dashboard/components/SettingsSection.vue';
import WithLabel from 'v3/components/Form/WithLabel.vue';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const { t } = useI18n();
const selected = ref('');
const isSubmitting = ref(false);

const statusOptions = computed(() =>
  Object.values(wootConstants.STATUS_TYPE)
    .filter(value => value !== wootConstants.STATUS_TYPE.OPEN)
    .map(value => ({
      value,
      label: t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${value}.TEXT`),
    }))
);

watch(
  () => props.inbox?.id,
  () => {
    const raw = props.inbox?.conversation_list_default_filter_status;
    selected.value =
      raw && raw !== wootConstants.STATUS_TYPE.OPEN ? raw : '';
  },
  { immediate: true }
);

const onChange = async () => {
  try {
    isSubmitting.value = true;
    await store.dispatch('inboxes/updateInbox', {
      id: props.inbox.id,
      formData: false,
      conversation_list_default_filter_status: selected.value || null,
    });
    useAlert(
      t('INBOX_MGMT.SETTINGS_POPUP.CONVERSATION_LIST_DEFAULT_FILTER.API_SUCCESS')
    );
  } catch (e) {
    useAlert(
      t('INBOX_MGMT.SETTINGS_POPUP.CONVERSATION_LIST_DEFAULT_FILTER.API_ERROR')
    );
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <div class="mx-8">
    <SettingsSection
      :title="
        $t('INBOX_MGMT.SETTINGS_POPUP.CONVERSATION_LIST_DEFAULT_FILTER.TITLE')
      "
      :sub-title="
        $t('INBOX_MGMT.SETTINGS_POPUP.CONVERSATION_LIST_DEFAULT_FILTER.SUBTITLE')
      "
    >
      <WithLabel
        :label="
          $t('INBOX_MGMT.SETTINGS_POPUP.CONVERSATION_LIST_DEFAULT_FILTER.LABEL')
        "
      >
        <select
          v-model="selected"
          class="!mb-0 w-full max-w-md text-sm"
          :disabled="isSubmitting"
          @change="onChange"
        >
          <option value="">
            {{
              $t(
                'INBOX_MGMT.SETTINGS_POPUP.CONVERSATION_LIST_DEFAULT_FILTER.DEFAULT_OPEN'
              )
            }}
          </option>
          <option
            v-for="opt in statusOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>
      </WithLabel>
    </SettingsSection>
  </div>
</template>
